import { useEffect, useRef } from "react";
import useTabVisibility from "./PageVisibility";

const useRepeatRefresh = (hours = 3) => {
  const isTabActive = useTabVisibility();
  const intervalIdRef = useRef<any>(null);

  useEffect(() => {
    // Whenever isTabActive changes, clear any existing interval
    if (intervalIdRef.current) {
      clearInterval(intervalIdRef.current);
      intervalIdRef.current = null;
    }

    // If tab is not active, start an interval that refreshes every X hours
    if (!isTabActive) {
      intervalIdRef.current = setInterval(() => {
        window.location.reload();
      }, hours * 60 * 60 * 1000);
    }

    // Cleanup on unmount or when isTabActive changes
    return () => {
      if (intervalIdRef.current) {
        clearInterval(intervalIdRef.current);
        intervalIdRef.current = null;
      }
    };
  }, [isTabActive, hours]);
};

export default useRepeatRefresh;